import PropertyService from 'src/common/api/property.service';

export async function getAllProperties({ commit }, { params }) {
  const response = await PropertyService.getAllProperties({ params });
  if (response.status === 200) {
    commit('setAll', { properties: response.data });
  }
}

export async function getProperty({ commit }, { propertyCode }) {
  const response = await PropertyService.getProperty({ propertyCode });
  if (response.status === 200) {
    commit('setProperty', { property: response.data });
  }
}

export async function getPropertyTransactions({ commit }, { propertyCode }) {
  const response = await PropertyService.getPropertyTransactions({ propertyCode });
  if (response.status === 200) {
    commit('setPropertyTransactions', { transactions: response.data });
  }
}

export async function lookupProperty(context, query) {
  const response = await PropertyService.lookupProperty({ params: query });
  if (response.status === 200) {
    return response.data;
  }

  return null;
}
